import { logAssert } from "@faire/web--source/common/logging";

import { useCurrentCategoryPage } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/currentCategoryPageContext";

export const useCurrentCategoryModel = () => {
  const [{ category: categoryModel }] = useCurrentCategoryPage(["category"]);

  logAssert(
    !!categoryModel,
    "Category model should be defined when you access it in a category page."
  );

  return categoryModel;
};
